import { apiHelper } from "./core"
import { apiHelperCS } from "./core"

const baseUrl = process.env.REACT_APP_CLINICAL_MANAGEMENT_BASE_URL
const baseUrlResource = process.env.REACT_APP_RESOURCE_MANAGEMENT_BASE_URL,
  masterServiceBaseUrl = process.env.REACT_APP_MASTER_BASE_URL

const addVital = (vital: any, info: any): Promise<any> => {
  let vitalDetail: any = {
    vitalCaptureDate: vital.vitalCaptureDate,
    previousVitalCaptureDate: vital.previousVitalCaptureDate,
    bpDiastolic: vital.bpDiastolic,
    bpSystolic: vital.bpSystolic,
    pulseInfo: vital.Pulse,
    height: vital.Height,
    weight: vital.Weight,
    bsa: vital["BSA"],
    bmi: vital["BMI"],
    hgt: vital["HGT-mg/dl"],
    anc: vital["Absolute Neutrophil Count (ANC)"],
    temperature: vital.Temperature,
    spo2: vital.SPO2,
    hemoglobin: vital.Haemoglobin,
    wbcCount: vital["Total WBC Count"],
    plateletsCount: vital["Platelets Count"],
    serumCreatinine: vital["Serum Creatinine"],
    egfr: vital["eGFR- Creat Clearance"],
    totalBilirubinDirect: vital["Total Bilirubin"],
    sgpt: vital["ALT (SGPT)"],
    sgot: vital["SGOT (AST)"],
    serumBilirubinDirect: vital["Serum Bilirubin Direct"],
    serumBilirubinInDirect: vital["Serum Bilirubin Indirect"],
    totalProtein: vital["Total Protein"],
    salbumin: vital["Albumin"],
    scalcium: vital["S.Calcium"],
    globulin: vital.Globulin,
    agRatio: vital["AG Ratio"],
    alkalinePhosphate: vital["Alkaline Phosphatase"],
    ggt: vital.GGT,
    bun: vital.BUN,
    urea: vital.Urea,
    uricAcid: vital["Uric Acid"],
    sodium: vital.Sodium,
    potassium: vital.Potassium,
    chloride: vital.Chloride,
    ldh: vital.LDH,
  }
  console.log("vital Detail", vitalDetail)
  return apiHelper
    .put(baseUrl + `/medicalrecords/${info.recordId}/vitals`, vitalDetail)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}
const raiseRmoApprovalRequest = (payload: any): Promise<any> => {
  return apiHelper
    .post(baseUrl + "/rmo-approval", payload)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}
const addCaseSummary = (summary: any, info: any): Promise<any> => {
  // let caseSummary: any = {
  //   comorbidities: summary?.comorbidities,
  //   drugHistoryAndAllergies: summary?.drugs,
  //   menstrualHistory: summary?.menstrualHistory,
  //   obstetricsHistory: {
  //     g: summary?.g,
  //     p: summary?.p,
  //     a: summary?.a,
  //     l: summary?.l,
  //   },
  //   pastHistory: [
  //     {
  //       cancerHistory: summary?.cancerHistory,
  //       cancerHistoryDetail: summary?.cancerHistoryDetail,
  //     },
  //     {
  //       radiation: summary?.radiation,
  //       radiationDetail: summary?.radiationDetail,
  //     },
  //     {
  //       surgery: summary?.surgery,
  //       surgeryDetail: summary?.surgeryDetail,
  //     },
  //     {
  //       others: summary?.pastHistoryOthers,
  //     },
  //   ],
  //   familyHistory: summary?.familyHistories,
  //   socioHistory: {
  //     tobbacco: summary?.tobbacco,
  //     tobbaccoDuration:
  //       summary?.tobbaccoNumber && summary?.tobbaccoDuration
  //         ? summary?.tobbaccoNumber + "$" + summary?.tobbaccoDuration
  //         : summary?.tobbaccoNumber && !summary?.tobbaccoDuration
  //         ? summary?.tobbaccoNumber + "$" + ""
  //         : !summary?.tobbaccoNumber && summary?.tobbaccoDuration
  //         ? "" + "$" + summary?.tobbaccoDuration
  //         : "",
  //     smoking: summary?.smoking,
  //     smokingDuration:
  //       summary?.smokingNumber && summary?.smokingDuration
  //         ? summary?.smokingNumber + "$" + summary?.smokingDuration
  //         : summary?.smokingNumber && !summary?.smokingDuration
  //         ? summary?.smokingNumber + "$" + ""
  //         : !summary?.smokingNumber && summary?.smokingDuration
  //         ? "" + "$" + summary?.smokingDuration
  //         : "",
  //     alcohol: summary?.alcohol,
  //     alcoholDuration:
  //       summary?.alcoholNumber && summary?.alcoholDuration
  //         ? summary?.alcoholNumber + "$" + summary?.alcoholDuration
  //         : summary?.alcoholNumber && !summary?.alcoholDuration
  //         ? summary?.alcoholNumber + "$" + ""
  //         : !summary?.alcoholNumber && summary?.alcoholDuration
  //         ? "" + +"$" + summary?.alcoholDuration
  //         : "",
  //     vaccinationHistory: summary?.vaccinationHistory,
  //     influenza: summary?.influenza,
  //     hepB: summary?.hepB,
  //     covid: summary?.covid,
  //     vaccinationOther: summary?.vaccinationOther,
  //   },
  // }
  return apiHelper
    .post(
      baseUrl + `/patient-clinical-data/history?patientId=${info.patientId}`,
      summary
    )
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}
const addInitialExamination = (examination: any, info: any): Promise<any> => {
  console.log("addInitialExamination", examination)
  const temp = examination.symptoms.map((e: any) => {
    if (e?.symotomsOthers) {
      let t = { ...e }
      t["symptoms"] = t["symotomsOthers"]
      delete t["symotomsOthers"]
      console.log(e, t, "ettt")
      return { ...t }
    } else {
      return { ...e }
    }
  })
  let initialExamination: any = {
    chiefComplaints: temp,
    generalExamination: {
      remarks: examination.remarks,
      pallor: examination.pallor,
      PallorOption: examination.pallor2,
      icterus: examination.icterus,
      cynosis: examination.cynosis,
      cynosisOption: examination.cynosis2,
      clubbing: examination.clubbing,
      LymphNodes: examination.lymphNodes,
      LymphNodesOption: examination.lymphNodes2,
      edema: examination.oedema,
      edemaOption: examination.oedema2,
      jvp: examination.jvp,
      nutritionalState: examination.nutritionalState,
      gait: examination.gait,
    },
    systemicExamination: {
      CNS: examination.cns,
      cnsOtherFinding: examination.cnsotherFinding,
      CVS: examination.cvs,
      cvsOtherFinding: examination.cvsOtherFinding,
      ENT: examination.ent,
      entOtherFinding: examination.entOtherFinding,
      RS: examination.rs,
      rsOtherFinding: examination.rsOtherFinding,
      PA: examination.pa,
      paOtherFinding: examination.paOtherFinding,
      pv: examination.pv,
      pvOtherFinding: examination.pvOtherFinding,
      pr: examination.pr,
      prOtherFinding: examination.prOtherFinding,
      systematicOtherFinding: examination.provisionalDiagnosis,
    },
    kps: examination.kps,
    ecogStatus: examination.ecogStatus,
  }
  return apiHelper
    .put(
      baseUrl + `/medicalrecords/${info.recordId}/initial-examination-info`,
      initialExamination
    )
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}
const getCancerList = (): Promise<any> => {
  return apiHelper.get(
    `${masterServiceBaseUrl}/form-templates/types?type=CANCER`
  )
}
const getFollowSheet = (PatientId: any): Promise<any> => {
  return apiHelper.get(
    `${baseUrl}/chemo-order/flowsheet?patientId=${PatientId}`
  )
}
const getCancerTemplate = (cancerType: string): Promise<any> => {
  return apiHelper.get(
    `${masterServiceBaseUrl}/form-templates/json?type=CANCER&subTypes=${cancerType}`,
    {}
  )
}
const getConsentTemplate = (
  type: string,
  templateName: string
): Promise<any> => {
  return apiHelper
    .get(`${masterServiceBaseUrl}/form-templates/${templateName}/json`)
    .then((response) => {
      return response?.data
    })
    .catch((error: any) => {
      return Promise.reject(error)
    })
}
const addCancerTemplateData = (
  cancerData: any,
  stagingData: any,
  id: any
): Promise<any> => {
  const cancer = {
    staging: cancerData,
    diagnosis: stagingData,
  }
  return apiHelper
    .post(`${baseUrl}/patient-clinical-data/staging?patientId=${id}`, cancer)
    .then((res) => {
      return res?.data
    })
}
const getCancerTemplateData = (info: any): Promise<any> => {
  return apiHelper
    .get(
      `${baseUrl}/patient-clinical-data/staging?patientId=${info?.patientId}`
    )
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}
const getPatientHistory = (id: any): Promise<any> => {
  return apiHelper.get(
    baseUrlResource + `/appointments?pastOrUpcoming=PAST&patientId=${id}`
  )
}

const getCancerTemplateDataName = (query: any): Promise<any> => {
  let url = query ? `form-templates/merge?${query}` : "form-templates/merge?"
  return apiHelper.get(`${masterServiceBaseUrl}/${url}`)
}
const getVitals = (
  recordId: any,
  ignoreAutopopulatedVitals: any = false
): Promise<any> => {
  return apiHelper.get(
    baseUrl +
    `/medicalrecords/${recordId}/vitals${ignoreAutopopulatedVitals
      ? `?ignoreAutopopulatedVitals=${ignoreAutopopulatedVitals}`
      : ""
    }`
  )
}
const getAllVitals = (recordId: any): Promise<any> => {
  return apiHelper.get(baseUrl + `/medicalrecords/${recordId}/additionalVitals`)
}
const getInitialExaminationData = (recordId: any): Promise<any> => {
  return apiHelper.get(
    baseUrl + `/medicalrecords/${recordId}/initial-examination-info`
  )
}
const getCaseSummaryData = (patientId: any): Promise<any> => {
  return apiHelper.get(
    baseUrl + `/patient-clinical-data/history?patientId=${patientId}`
  )
}
const getConsultantNotesData = (patientId: any): Promise<any> => {
  return apiHelper.get(
    baseUrl + `/patient-clinical-data/consultant-notes?patientId=${patientId}`
  )
}
const getICDList = (cancerType: any): Promise<any> => {
  return apiHelper.get(`${baseUrl}/icd/check?q=${cancerType}`)
}
const addConsultantNotes = (consultant: any, info: any): Promise<any> => {
  let nextVisitTemp = ""
  if (consultant?.nextVisit !== "") {
    nextVisitTemp = consultant?.nextVisit
  } else if (consultant?.nextVisit1 !== "" && consultant?.nextVisit2 !== "") {
    nextVisitTemp = `${consultant?.nextVisit1}$${consultant?.nextVisit2}`
  } else {
    nextVisitTemp = ""
  }
  let consultantDetails: any = {
    prescriptionPad: consultant?.prescriptionPlans,
    testsRequired: consultant?.testsRequested,
    advice: consultant?.advice,
    nextVisit: nextVisitTemp,
    referredTo: consultant?.referredTos,
  }

  console.log("consultant Detail", consultantDetails)
  return apiHelper
    .post(
      baseUrl +
      `/patient-clinical-data/consultant-notes?patientId=${info.patientId}`,
      consultantDetails
    )
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const addFollowUP = (follow: any, info: any): Promise<any> => {
  let nextVisitTemp = ""
  if (follow?.nextVisit !== "") {
    nextVisitTemp = follow?.nextVisit
  } else if (follow?.nextVisit1 !== "" && follow?.nextVisit2 !== "") {
    nextVisitTemp = `${follow?.nextVisit1}$${follow?.nextVisit2}`
  } else {
    nextVisitTemp = ""
  }
  let followUpDetails: any = {
    briefHistory: follow?.briefHistory,
    complaints: follow?.complaints,
    examination: follow?.examination,
    clinicalImpressions: follow?.clinicalImpression,
    testsRequired: null,
    notes: follow?.notes,
    prescriptionPad: null,
    advice: follow?.advice,
    nextVisit: nextVisitTemp,
    referredTo: follow?.updatedReferedTos,
    signatureDetails: follow?.temp,
  }
  return apiHelper
    .put(
      baseUrl + `/medicalrecords/${info.recordId}/follow-up-info`,
      followUpDetails
    )
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}
const addAudio = (
  recordId: String,
  file: String,
  fileName: string
): Promise<any> => {
  const audioData: any = {
    audios: {
      name: fileName,
      blobUrl: file,
    },
  }
  return apiHelper
    .patch(baseUrl + `/medicalrecords/${recordId}/media`, audioData)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}
const addDrawing = (recordId: String, file: String): Promise<any> => {
  console.log(recordId)
  const drawingData: any = {
    writings: {
      name: "drawing.png",
      blobUrl: file,
    },
  }
  return apiHelper
    .patch(baseUrl + `/medicalrecords/${recordId}/media`, drawingData)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const getStage = (url: any): Promise<any> => {
  return apiHelper
    .get(masterServiceBaseUrl + url)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}
const getDrawing = (recordId: any): Promise<any> => {
  return apiHelper
    .get(baseUrl + "/medicalrecords/" + recordId)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const getLesions = (data: any): Promise<any> => {
  let url =
    data?.type === "With Target Lesions"
      ? `/response-criteria?withTargetLesion=true&targetLesionResponse=${data?.targetLesionsResponse}&nonTargetLesionResponse=${data?.nonTargetLesionsResponse}&newLesions=${data?.newLesions}`
      : `/response-criteria?withTargetLesion=false&nonTargetLesionResponse=${data?.nonTargetLesionsResponse}&newLesions=${data?.newLesions}`

  return apiHelper
    .get(masterServiceBaseUrl + url)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const savePrescription = (id: any, data: any, count: any) => {
  return apiHelper
    .put(
      baseUrl +
      `/medicalrecords/${id}/prescription/save?prescriptionCount=${count}`,
      data
    )
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const updatePrescription = (id: any, data: any) => {
  const temp = { ...data }
  const prescriptionId = temp["prescriptionId"]
  // delete temp["id"]
  // delete temp["prescriptionId"]
  return apiHelper
    .put(
      baseUrl +
      `/medicalrecords/${id}/prescription/update?prescriptionId=${prescriptionId}`,
      temp
    )
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const sendPrescription = (id: any, data: any): Promise<any> => {
  const temp = { ...data }
  const prescriptionId = temp["prescriptionId"]
  // delete temp["id"]

  return apiHelper
    .put(
      baseUrl +
      `/medicalrecords/${id}/prescription/send?prescriptionId=${prescriptionId}`
    )
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const cancelPrescription = (id: any, data: any): Promise<any> => {
  const temp = { ...data }
  const prescriptionId = temp["prescriptionId"]
  // delete temp["id"]

  return apiHelper
    .put(
      baseUrl +
      `/medicalrecords/${id}/prescription/cancel?prescriptionId=${prescriptionId}`
    )
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const saveTest = (id: any, data: any, count: any) => {
  const tempData = { ...data }
  delete tempData["isCancelled"]
  delete tempData["id"]
  delete tempData["integrationOrderId"]
  delete tempData["isSent"]
  return apiHelper
    .put(
      baseUrl +
      `/medicalrecords/${id}/lab-prescription/save?labPrescriptionCount=${count}`,
      tempData
    )
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const updateTest = (id: any, data: any) => {
  const temp = { ...data }
  const prescriptionId = temp["id"]
  delete temp["id"]
  delete temp["isCancelled"]
  delete temp["isSent"]
  delete temp["integrationOrderId"]
  return apiHelper
    .put(
      baseUrl +
      `/medicalrecords/${id}/lab-prescription/update/${prescriptionId}`,
      temp
    )
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const sendTest = (id: any, data: any): Promise<any> => {
  const temp = { ...data }
  const prescriptionId = temp["id"]
  // delete temp["id"]

  return apiHelper
    .put(
      baseUrl + `/medicalrecords/${id}/lab-prescription/send/${prescriptionId}`
    )
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const cancelTest = (id: any, data: any): Promise<any> => {
  const temp = { ...data }
  const prescriptionId = temp["id"]
  // delete temp["id"]

  return apiHelper
    .put(
      baseUrl +
      `/medicalrecords/${id}/lab-prescription/cancel/${prescriptionId}`
    )
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const getTestsList = (centerId: any): Promise<any> => {
  return apiHelper
    .get(baseUrl + `/test/all?centerId=${centerId}`)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const getTemplatesByType = (type: any): Promise<any> => {
  return apiHelper
    .get(masterServiceBaseUrl + `/form-templates/type?type=${type}`)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const generateClinicalSummary = (
  id: any,
  clinicalTrue: any = false,
  dischargeTrue: any = false,
  forPrint: any = false,
  skipLoader: any = false
): Promise<any> => {
  const url: any = `${baseUrl}/medicalrecords/clinical-summary?appointmentId=${id}${clinicalTrue ? `&forViewOnly=${clinicalTrue}` : ""
    }${dischargeTrue ? `&forDischargeSummary=${dischargeTrue}` : ""}${forPrint ? `&forPrint=${forPrint}` : ""
    }`
  return apiHelperCS
    .get(url, { params: { skipLoader } })
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const dateCheck = (date: any, recordId: any): Promise<any> => {
  return apiHelper.get(
    baseUrl +
    `/medicalrecords/${recordId}/existingVitalsCheck?vitalsDate=${date}`
  )
}

const deleteVital = (date: any, recordId: any): Promise<any> => {
  return apiHelper.patch(
    baseUrl +
    `/medicalrecords/${recordId}/deleteAdditionalVitals?vitalsDate=${date}`
  )
}

export {
  addVital,
  getVitals,
  getAllVitals,
  getInitialExaminationData,
  getCaseSummaryData,
  getConsultantNotesData,
  raiseRmoApprovalRequest,
  addCaseSummary,
  addInitialExamination,
  getCancerList,
  getICDList,
  getCancerTemplate,
  getPatientHistory,
  addConsultantNotes,
  addFollowUP,
  getFollowSheet,
  addCancerTemplateData,
  getCancerTemplateData,
  getStage,
  getLesions,
  addAudio,
  addDrawing,
  getCancerTemplateDataName,
  getDrawing,
  getConsentTemplate,
  savePrescription,
  updatePrescription,
  sendPrescription,
  cancelPrescription,
  getTestsList,
  saveTest,
  updateTest,
  sendTest,
  cancelTest,
  getTemplatesByType,
  generateClinicalSummary,
  dateCheck,
  deleteVital,
}
